import { FunctionalComponent } from 'preact'
import classNames from 'classnames'

import DropdownControl from '../dropdown/DropdownControl'
import { Badge, BadgeList } from './index'
import DropdownImage from '../dropdown/DropdownImage'
import Button from '@insided/control/uikit/Button'
import { Item } from '../dropdown/interfaces'

export interface BadgeSelectorProps {
  badges: BadgeList
  selected: Badge | undefined
  onChange: Function
  error: string | undefined
}

const DropdownText = ({ badges, selected }: Pick<BadgeSelectorProps, 'badges' | 'selected'>) => {
  if (badges.length === 0) {
    return 'There are no badges available'
  }
  if (selected) {
    return (
      <span className='selected'>
        <div>{selected.image && <DropdownImage image={selected.image} />}</div>
        <div className='truncated'>{selected.title}</div>
      </span>
    )
  }
  return 'Choose a badge'
}

function normalizeBadges(badgeList: BadgeList, onChange: Function) {
  return badgeList.map((badge: Badge) => {
    const onClick: Item['onClick'] = (event) => {
      const target = event.target as HTMLAnchorElement
      onChange(target.getAttribute('value'))
    }
    return {
      value: badge.id,
      title: badge.title,
      image: badge.image,
      onClick,
      variant: 'primary'
    }
  })
}

const BadgeSelector: FunctionalComponent<BadgeSelectorProps> = ({
  badges,
  selected,
  onChange,
  error
}) => {
  const normalizedBadges = badges && normalizeBadges(badges, onChange)

  return (
    <div className='badge-selector-wrapper'>
      <DropdownControl
        align='adjust'
        trigger={
          <Button
            // @ts-expect-error
            title={<DropdownText badges={badges} selected={selected} />}
            className={classNames('badge-selector', 'qa-badge-selector', {
              error: error,
              'no-badge-selected-message': !selected
            })}
            icon='arrowDropdown'
          />
        }
        items={normalizedBadges}
        hasSearch
        closeOnDropdownClick
      />
      {error && <span className='error'>{error}</span>}
    </div>
  )
}

export default BadgeSelector
